/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The available sort by criteria to choose from.
 */
export type PlatformCatalogVersionSortByParam =
  (typeof PlatformCatalogVersionSortByParam)[keyof typeof PlatformCatalogVersionSortByParam];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatformCatalogVersionSortByParam = {
  VERSION_ASC: "VERSION_ASC",
  VERSION_DESC: "VERSION_DESC",
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
  PUBLISHED_FROM_ASC: "PUBLISHED_FROM_ASC",
  PUBLISHED_FROM_DESC: "PUBLISHED_FROM_DESC",
  PUBLISHED_UNTIL_ASC: "PUBLISHED_UNTIL_ASC",
  PUBLISHED_UNTIL_DESC: "PUBLISHED_UNTIL_DESC",
} as const;
